require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-automotive-the-digital-battleground.json") })
        }
      }, "path---authors-automotive-the-digital-battleground");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-automotive-the-digital-battleground!./.cache/json/authors-automotive-the-digital-battleground.json
// module id = 1257
// module chunks = 231608221292675